import * as React from 'react';

// tslint:disable:max-line-length
export const RailwayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" fillOpacity=".01" d="M1 1h14v14H1z" />
      <path
        fill="#757575"
        fillOpacity=".54"
        d="M11 12l1 3h-1l-1-3H6l-1 3H4l1-3h-.895a1 1 0 0 1-.995-1.1l.8-8a1 1 0 0 1 .995-.9h1.363a2 2 0 0 1 3.464 0h1.363a1 1 0 0 1 .995.9l.8 8a1 1 0 0 1-.995 1.1H11zM5 3v4h6V3H5zm0 6v1h1V9H5zm5 0v1h1V9h-1z"
      />
    </g>
  </svg>
);
